var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricIconFinished(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#FFF3E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#FFF9F2",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.3243 23.2226C10.5445 25.2807 12.1998 26.936 14.2569 27.1653C15.7848 27.3356 17.3536 27.4818 18.9531 27.4818C20.5526 27.4818 22.1214 27.3356 23.6492 27.1653C25.7064 26.936 27.3617 25.2807 27.5818 23.2226C27.7444 21.7033 27.8817 20.1435 27.8817 18.5533C27.8817 16.963 27.7444 15.4032 27.5818 13.8839C27.3617 11.8259 25.7064 10.1706 23.6492 9.94128C22.1214 9.77097 20.5526 9.62469 18.9531 9.62469C17.3536 9.62469 15.7848 9.77097 14.2569 9.94128C12.1998 10.1706 10.5445 11.8259 10.3243 13.8839C10.1618 15.4032 10.0245 16.963 10.0245 18.5533C10.0245 20.1435 10.1618 21.7033 10.3243 23.2226Z",
    fill: "#F3E1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3243 23.2226C10.5445 25.2807 12.1998 26.936 14.2569 27.1653C15.7848 27.3356 17.3536 27.4818 18.9531 27.4818C20.5526 27.4818 22.1214 27.3356 23.6492 27.1653C25.7064 26.936 27.3617 25.2807 27.5818 23.2226C27.7444 21.7033 27.8817 20.1435 27.8817 18.5533C27.8817 16.963 27.7444 15.4032 27.5818 13.8839C27.3617 11.8259 25.7064 10.1706 23.6492 9.94128C22.1214 9.77097 20.5526 9.62469 18.9531 9.62469C17.3536 9.62469 15.7848 9.77097 14.2569 9.94128C12.1998 10.1706 10.5445 11.8259 10.3243 13.8839C10.1618 15.4032 10.0245 16.963 10.0245 18.5533C10.0245 20.1435 10.1618 21.7033 10.3243 23.2226Z",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1391 18.6034L17.7365 21.282C18.9588 17.771 19.9767 16.2303 22.282 14.1391",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconFinished);
export default __webpack_public_path__ + "static/media/MetricIconFinished.d7e64f20a692085cdd4b24a1635fa6da.svg";
export { ForwardRef as ReactComponent };